if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');
      if (!recommendations) return;
      if (this.dataset.static === 'true') {
        const hasItems = recommendations.children.length > 0;
        const cartItems = document.querySelector('.cart-drawer-items');
        if (cartItems) {
          if (hasItems) cartItems.classList.remove('cart-drawer-items__full');
          else cartItems.classList.add('cart-drawer-items__full');
        }
        if (hasItems) {
          this.classList.remove('hidden');
          this.initSlider();
          setTimeout(() => {
            const quickCart = document.querySelector('quick-cart-drawer');
            if (quickCart && typeof quickCart.init === 'function') quickCart.init();
            else this.querySelectorAll('.quick-cart-drawer__trigger').forEach(el => el?.remove());
            this.initDirectAddHandlers();
          }, 500);
        }
        return;
      }

      const productIdsAttr = this.dataset.productIds;
      const baseUrl = this.dataset.urlBase;
      const limit = parseInt(this.dataset.limit || '0', 10) || 8;

      const updateCartItemsLayout = (hasRecommendations) => {
        const cartItems = document.querySelector('.cart-drawer-items');
        if (!cartItems) return;
        if (hasRecommendations) {
          cartItems.classList.remove('cart-drawer-items__full');
        } else {
          cartItems.classList.add('cart-drawer-items__full');
        }
      };

      if (productIdsAttr && baseUrl) {
        const ids = Array.from(new Set(productIdsAttr.split(',').map(id => id.trim()).filter(Boolean)));
        if (ids.length === 0) {
          updateCartItemsLayout(false);
          return;
        }

        Promise.all(
          ids.map(id => fetch(`${baseUrl}&product_id=${encodeURIComponent(id)}&limit=${limit}`).then(r => r.text()).catch(() => ''))
        ).then(responses => {
          const parser = new DOMParser();
          const uniqueByHref = new Map();

          responses.forEach(htmlText => {
            if (!htmlText) return;
            const doc = parser.parseFromString(htmlText, 'text/html');
            const container = doc.querySelector('[data-recommendations]');
            if (!container) return;
            container.querySelectorAll('.product-recommendations__item').forEach(item => {
              const href = item.getAttribute('href');
              if (!href) return;
              if (!uniqueByHref.has(href)) {
                uniqueByHref.set(href, item.outerHTML);
              }
            });
          });

          const merged = Array.from(uniqueByHref.values()).slice(0, limit);
          if (merged.length === 0) {
            updateCartItemsLayout(false);
            return;
          }

          this.classList.remove('hidden');
          updateCartItemsLayout(true);
          recommendations.innerHTML = merged.join('');
          this.initSlider();

          setTimeout(() => {
            const quickCart = document.querySelector('quick-cart-drawer');
            if (quickCart && typeof quickCart.init === 'function') {
              quickCart.init();
            } else {
              this.querySelectorAll('.quick-cart-drawer__trigger').forEach(el => el?.remove());
            }
            this.initDirectAddHandlers();
          }, 500);
        });
        return;
      }

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) {
            const cartItems = document.querySelector('.cart-drawer-items');
            if (cartItems) cartItems.classList.add('cart-drawer-items__full');
            return;
          }
          this.classList.remove('hidden');
          const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if (cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
            this.initDirectAddHandlers();
          }, 500);

        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 1.1,
        spaceBetween: 8,
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },
        breakpoints: {
          750: {
            slidesPerView: 1.3,
            spaceBetween: 16,
          }
        }
      });
    }

    initDirectAddHandlers() {
      const directButtons = this.querySelectorAll('.quick-cart-drawer__trigger[data-direct-add="true"][data-variant-id]');
      if (!directButtons.length) return;

      directButtons.forEach(button => {
        if (button._directAddInit) return;
        button._directAddInit = true;
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          document.querySelector('.appstle_subscription_wrapper_option:not(.appstle-active-option) .appstle_one_time_details_wrapper label')?.click();
          const trigger = event.currentTarget;
          const variantId = trigger.getAttribute('data-variant-id');
          if (!variantId) return;

          trigger.classList.add('is--loading');
          try {
            const cartDrawer = document.querySelector('cart-drawer');
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');
            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
              formData.append('sections', cartDrawer.getSectionsToRender().map(s => s.section));
              formData.append('sections_url', window.location.pathname);
            }
            config.body = formData;

            const response = await fetch(`${routes.cart_add_url}`, config);
            const data = await response.json();
            if (data.status) {
              console.error('Add to cart error:', data.message || data.description || data.errors);
              return;
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
            } else {
              window.location = window.routes.cart_url;
            }
          } catch (e) {
            console.error(e);
          } finally {
            trigger.classList.remove('is--loading');
          }
        });
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
